module.exports = __webpack_public_path__ + "static/media/capsule_machine_en.b8e8ff0e.png";